import {BaseModel} from '../base/BaseModel';

/**
 * @class SprayWeatherModel
 * @extends BaseModel
 *
 * @property {object} attributes
 */
export class SprayWeatherModel extends BaseModel {

    get defaults () {

        return {
            objectType: undefined,
            objectUuid: undefined,
            modelUuid: undefined,
            fromDate: undefined,
            toDate: undefined,
            result: undefined,
            factors: undefined
        };
    }

    parse (modelToParse) {

        modelToParse.fromDate = BaseModel.parseDate(modelToParse.fromDate);
        modelToParse.toDate = BaseModel.parseDate(modelToParse.toDate);

        return modelToParse;
    }

    static get RESULTS () {

        return {
            GOOD: 'good',
            MODERATE: 'moderate',
            BAD: 'bad',
            UNKNOWN: 'unknown'
        }
    }

    static get FACTORS () {

        return {
            AIR_TEMPERATURE: 'AIR_TEMPERATURE',
            WIND: 'WIND',
            PRECIPITATION: 'PRECIPITATION',
            RELATIVE_HUMIDITY: 'RELATIVE_HUMIDITY',
            DELTA_T: 'DELTA_T'
        }
    }
}


// WEBPACK FOOTER //
// ./shared/model/weather/SprayWeatherModel.js